module.exports = __webpack_public_path__ + "img/farming_5.4f03ff5d.png";